import { mockStudents } from '../data/mockData';

const STORAGE_KEY = 'safeguardpro_students_v1';
const cloneDefaults = () => JSON.parse(JSON.stringify(mockStudents));

export default class StudentRepository {
  load() {
    try {
      const stored = typeof window !== 'undefined' ? window.localStorage.getItem(STORAGE_KEY) : null;
      if (stored) {
        const parsed = JSON.parse(stored);
        if (Array.isArray(parsed)) {
          return parsed;
        }
      }
      const defaults = cloneDefaults();
      this.persist(defaults);
      return defaults;
    } catch (error) {
      const defaults = cloneDefaults();
      this.persist(defaults);
      return defaults;
    }
  }

  persist(data) {
    if (typeof window === 'undefined') return;
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (error) {
      if (error && error.name === 'QuotaExceededError') {
        // Surface a clear signal to callers so UI can show an error and avoid silent data loss.
        const quotaError = new Error('STORAGE_QUOTA_EXCEEDED');
        quotaError.original = error;
        throw quotaError;
      }
      throw error;
    }
  }

  getAll() {
    return [...this.load()];
  }

  getById(id) {
    return this.load().find((s) => s.id === id) || null;
  }

  create(student) {
    const current = this.load();
    const next = [student, ...current];
    this.persist(next);
    return student;
  }

  update(id, updated) {
    const current = this.load();
    const next = current.map((s) => (s.id === id ? updated : s));
    this.persist(next);
    return updated;
  }

  remove(id) {
    const current = this.load();
    const next = current.filter((s) => s.id !== id);
    this.persist(next);
  }
}
